import { SettingsWebsite } from '@lib/types';

export function organisationId(website: SettingsWebsite): string {
  return `${stripTrailingSlash(website.url)}/#organisation`;
}

export function webSiteId(website: SettingsWebsite): string {
  return `${stripTrailingSlash(website.url)}/#website`;
}

export function productId(
  website: SettingsWebsite,
  structuredDataId: string,
): string {
  return `${stripTrailingSlash(website.url)}/#product-${structuredDataId}`;
}

export function articleId(canonicalUrl: string): string {
  return `${stripTrailingSlash(canonicalUrl)}/#article`;
}

function stripTrailingSlash(url: string): string {
  return url.endsWith('/') ? url.slice(0, -1) : url;
}
